<template>
  <Head title="Create Account" />
  <div
    class="from-navy-50 to-navy-100 relative flex min-h-screen items-center justify-center bg-gradient-to-br via-neutral-50 px-4 py-12 sm:px-6 lg:px-8"
  >
    <div
      class="from-navy-500/5 absolute inset-0 bg-gradient-to-br to-green-500/10"
    ></div>

    <div class="relative z-10 w-full max-w-md">
      <div
        class="rounded-2xl border border-neutral-200 bg-white p-8 shadow-xl transition-shadow duration-300 hover:shadow-2xl"
      >
        <div class="mb-8 text-center">
          <img
            src="/assets/trellis-logo.svg"
            alt="Trellis"
            class="mx-auto mb-4 h-10 w-auto"
          />
          <p class="text-navy-600 text-sm">Join {{ companyName }}</p>
        </div>

        <form class="space-y-6" @submit.prevent="form.post('/registration')">
          <div>
            <label
              for="email"
              class="text-navy-700 mb-1.5 block text-sm font-medium"
            >
              Email Address
            </label>
            <input
              id="email"
              :value="email"
              type="email"
              disabled
              class="text-navy-500 w-full rounded-md border border-neutral-200 bg-neutral-50 px-4 py-2.5"
            />
          </div>

          <AppInput
            v-model="form.name"
            label="Full Name"
            type="text"
            placeholder="Enter your full name"
            :error="form.errors.name?.[0]"
            required
            autofocus
          />

          <AppInput
            v-model="form.password"
            label="Password"
            type="password"
            placeholder="Create a password"
            :error="form.errors.password?.[0]"
            required
          />

          <AppInput
            v-model="form.password_confirmation"
            label="Confirm Password"
            type="password"
            placeholder="Confirm your password"
            :error="form.errors.password_confirmation?.[0]"
            required
          />

          <AppButton type="submit" :loading="form.processing" class="w-full">
            Create Account
          </AppButton>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Head, useForm } from "@inertiajs/vue3"

import AppButton from "../../components/ui/AppButton.vue"
import AppInput from "../../components/ui/AppInput.vue"

interface Props {
  email: string
  company_name: string
}

const props = defineProps<Props>()

const companyName = props.company_name

const form = useForm({
  name: "",
  password: "",
  password_confirmation: "",
})

defineOptions({ layout: false })
</script>
